<div #wgChartContainer class="weather-graph-chart-container" style="position: relative;">
    <highcharts-chart *ngIf="chartOptions"  [Highcharts]="Highcharts" [options]="chartOptions">
    </highcharts-chart>
    <div *ngIf="isResizingChart && chart" id="wa-resize-notice">{{'STRINGS.RESIZING_CHART' | translate}}...</div>
    <div *ngIf="showNoDataNotice" id="wa-no-data-notice">{{'STRINGS.NO_CHART_DATA_TO_DISPLAY' | translate}}</div>
    <toro-waiting-indicator class="widget-non-draggable" *ngIf="isBusy" [isVisible]="isBusy" backgroundColor="rgba(255,255,255, .9)"></toro-waiting-indicator>
</div>
